<template>
    <el-container>
        <el-main>
            <el-form ref="searchData" :model="searchData" label-width="80px" label-position="top">
                <el-row >
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="机构名称" prop="organizationName">
                            <el-input v-model="searchData.organizationName"  placeholder="机构名称" size="small" style="width: 70%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="上级机构" prop="parentCode">
                            <el-select v-model="searchData.parentCode" clearable placeholder="上级机构" size="small" style="width: 70%">
                                <el-option v-for="item in org" :label="item.organizationName" :value="item.orgCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="机构状态" prop="status" >
                            <el-select v-model="searchData.status" clearable placeholder="机构状态" size="small" style="width: 70%">
                                <el-option label="启用" :value="1"></el-option>
                                <el-option label="停用" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item >
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="searchOrg()">查询</el-button>
                </el-form-item>
    
            </el-form>
            <el-dialog :title="title" :visible.sync="addOrg" width="30%" :close-on-click-modal=false :before-close="handleDialogClose">
                <el-form ref="formData"  :model="formData" :rules="rules" label-width="100px"  class="demo-ruleForm">
                    <el-form-item label="机构编号" prop="orgCode">
                        <el-input v-model="formData.orgCode"  placeholder="机构编号" :disabled="orgCodeDisable"></el-input>
                    </el-form-item>
                    <el-form-item label="机构名称" prop="organizationName">
                        <el-input v-model="formData.organizationName"  placeholder="机构名称"></el-input>
                    </el-form-item>
                    <el-form-item label="上级机构" prop="parentCode">
                        <el-select v-model="formData.parentCode" clearable placeholder="上级机构" style="width: 100%" :disabled="orgCodeDisable">
                            <el-option v-for="item in org" :label="item.organizationName" :value="item.orgCode"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="机构logo:" prop="organizationLogo">
                        <el-upload
                            v-model="formData.organizationLogo"
                            :action="uploadURL"
                            :headers="myHeaders"
                            :class="{'hide': hidePictureUpload}"
                            list-type="picture-card"
                            :on-remove="pictureHandleRemove"
                            :on-change="pictureOnChange"
                            :on-success="pictureHandleSuccess"
                            :before-upload="pictureBeforeAvatarUpload"
                            :limit="1"
                            :file-list="pictureFileList"
                            :show-file-list="true"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" size="tiny">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <el-form-item label="首页封面:" prop="webPic">
                        <el-upload
                            v-model="formData.webPic"
                            :action="uploadURL"
                            :headers="myHeaders"
                            :class="{'hide': hideWebPicUpload}"
                            list-type="picture-card"
                            :on-remove="webPicHandleRemove"
                            :on-change="webPicOnChange"
                            :on-success="webPicHandleSuccess"
                            :before-upload="pictureBeforeAvatarUpload"
                            :limit="1"
                            :file-list="webPicFileList"
                            :show-file-list="true"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogWebPicVisible" size="tiny">
                            <img width="100%" :src="dialogWebPicImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <el-form-item label="申请人" prop="realName">
                        <el-input v-model="formData.realName"  placeholder="申请人"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model="formData.phone"  placeholder="手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="formData.email"  placeholder="邮箱"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="主营类目" prop="ccId">-->
                        <!--<el-select v-model="formData.ccId" clearable placeholder="主营类目" size="small">-->
                            <!--<el-option v-for="item in courseData" :label="item.ccName" :value="item.ccId"></el-option>-->
                        <!--</el-select>-->
                    <!--</el-form-item>-->

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose">取 消</el-button>
                    <el-button type="primary" @click="saveOrg('formData')">确 定</el-button>
                </div>
            </el-dialog>

            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addOrg = true" class="but-cls">添加</el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteMore" class="but-cls">删除</el-button>
            <el-table
                    :data="orgData"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                    prop="orgCode"
                    label="机构编号"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="organizationName"
                        label="机构名称"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="parentName"
                    label="上级机构"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="realName"
                        label="申请人"
                        width="100"
                >
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手机号"
                        width="200"
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态"
                        width="200"
                        align="center"
                >
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="2"
                            :active-text="statusText[scope.row.orgCode]"
                            inactive-text=""
                            @change="changeStatus(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template slot-scope="scope">
                        <el-button @click="updateRole(scope.$index, scope.row)" type="text"  size="small">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import validate from '@/api/validate.js'
    const formData = {
      organizationName: "",
      organizationId: "",
      orgCode: "",
      parentCode: '',
      phone: "",
      status: "1",
      approvalStatus : "1",
      realName: "",
      email: "",
      organizationLogo: "",
      webPic: "",
      type: "",
      ccId: "",
    }
    export default {
        name: "",
        data() {
            return {
              myHeaders: {
                Authentication: localStorage.getItem("token")
                // Authorization
              },
                orgData: [],
                org: [],
                formData: JSON.parse(JSON.stringify(formData)),
                searchData: {
                    organizationName: "",
                    status: "",
                    parentCode: '',
                    page: 1,
                    size: 10
                },
                rules: {
                    orgCode: [
                      { required: true, message: '请输入机构编号', trigger: 'blur' },
                      { validator: validate.validateOrgCode, trigger: 'blur' }
                    ],
                    organizationName: [
                      { required: true, message: '请输入机构名称', trigger: 'blur' },
                      { max:20, message: '长度不得超过20个字符', trigger: 'blur' }
                    ],
                      phone: [
                        {required: true, message: '请输入电话', trigger: 'blur' },
                        { validator: validate.validatePhone, trigger: 'blur' }
                      ],
                      realName: [
                        {required: true, message: '请输入申请人姓名', trigger: 'blur' },
                        { max:20, message: '长度不得超过20个字符', trigger: 'blur' }
                      ],
                      email: [
                        { validator: validate.validateEmail, trigger: 'blur' }
                      ],
                  organizationLogo: [
                    {required: true, message: '请上传机构logo', trigger: 'change' },
                  ],
                  webPic: [
                    {required: true, message: '请上传首页封面', trigger: 'change' },
                  ],
                },
              statusText: {},
              uploadURL: '',
              hidePictureUpload: false,
              hideWebPicUpload: false,
              pictureLimitCount: 1,
              webPicLimitCount: 1,
              currentPage: 1,
                loading: false,
                total: 0,
                addOrg: false,
                pageSize: 10,
                multipleSelection: [],
              pictureFileList: [],
              webPicFileList: [],
              dialogImageUrl: "",
              dialogVisible: false,
              dialogWebPicImageUrl: "",
              dialogWebPicVisible: false,
              orgCodeDisable: false,
              courseData: [],
              title: "添加机构",
            }
        },
        methods: {
          handlePictureCardPreview(file) {
            this.dialogVisible = true;
            this.dialogImageUrl = file.url;
          },
          handleWebPicCardPreview(file) {
            this.dialogWebPicVisible = true;
            this.dialogWebPicImageUrl = file.url;
          },
          pictureHandleRemove(file, fileList) {
            this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
          },
          webPicHandleRemove(file, fileList) {
            this.hideWebPicUpload = fileList.length >= this.webPicLimitCount;
          },
          pictureOnChange(file, fileList) {
            this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
          },
          webPicOnChange(file, fileList) {
            this.hideWebPicUpload = fileList.length >= this.webPicLimitCount;
          },
          pictureHandleSuccess(response) {
            this.pictureFileList = [];
            this.formData.organizationLogo = response.data.filePath;
            let file = {
              name: '123.png',
              url: response.data.filePath
            };
            this.pictureFileList.push(file);
          },
          webPicHandleSuccess(response) {
            this.webPicFileList = [];
            this.formData.webPic = response.data.filePath;
            let file = {
              name: '123.png',
              url: response.data.filePath
            };
            this.webPicFileList.push(file);
          },
          pictureBeforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
            const isLt2M = file.size / 1024 / 1024 < 20;

            if (!isJPG) {
              this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
            }
            if (!isLt2M) {
              this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
          },
            handleSizeChange() {},
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].organizationId;
                }
            },
            formatVerifyStatus(row, column, cellValue, index) {
                //0 未审核，1 审核成功，2 审核失败
                if(cellValue == 0) {
                    return "未审核";
                }else if(cellValue == 1) {
                    return "审核成功";
                }else if(cellValue == 2) {
                    return "审核失败"
                } else {
                    return "其他";
                }
            },
            detail(index, row) {
            
            },
          updateRole(index, row) {
            this.title="修改机构";
            this.addOrg = true;
            this.orgCodeDisable = true;
            this.formData = JSON.parse(JSON.stringify(row));
            let logo = {
              name: "",
              url: this.formData.organizationLogo
            };
            this.pictureFileList.push(logo);
            this.hidePictureUpload = this.pictureFileList.length >= this.pictureLimitCount;
            let webPic = {
              name: "",
              url: this.formData.webPic
            };
            this.webPicFileList.push(webPic);
            this.hideWebPicUpload = this.webPicFileList.length >= this.webPicLimitCount;
          },
          handleDialogClose() {
            this.$refs["formData"].clearValidate();
            this.title="添加机构";
            this.addOrg = false;
            this.formData = JSON.parse(JSON.stringify(formData));
            this.webPicFileList = [];
            this.pictureFileList = [];
            this.hidePictureUpload = false;
            this.hideWebPicUpload = false;
            this.orgCodeDisable = false;
          },
          changeStatus(row) {
            let params = {
              organizationId: row.organizationId,
              status: row.status
            }
            https.fetchPost("/managerOrganization/updateOrganization",params ,"json").then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if(code == '200') {
                this.$forceUpdate();
                console.log(this.statusText);
                if(row.status === 2) {
                  this.$set(this.statusText,row.orgCode,"停用");
                }
                if(row.status === 1) {
                  this.$set(this.statusText,row.orgCode,"启用");
                }
                console.log(this.statusText);
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
              } else {
                this.$message.error('操作失败:'+msg);
                if(row.status === 2) {
                  row.status = 1;
                } else {
                  row.status = 2;
                }
              }

            }).catch(err=>{
                  console.log(err);
                  this.$message.error('网络错误');
                }
            )
            
          },
          deleteOrg(index,row) {
            this.$confirm('此操作将删除该机构信息, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(()=>{
              let params = [row.organizationId]
              https.fetchPost('/managerOrganization/deleteByOrganizationIdList',params , "json").then((data) => {
                let code = data.data.code;
                let msg = data.data.msg;
                if(code == '200') {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  this.searchOrg();
                } else {
                  this.$message({
                    type: 'info',
                    message: '删除失败：'+msg
                  });
                }
              }).catch(err=>{
                    this.$message.error('网络错误');
                  }
              )
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          },
            deleteMore() {
                let roleLength = this.multipleSelection.length;
                this.$confirm('此操作将删除'+roleLength+'条角色信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let params = this.multipleSelection
                    https.fetchPost('/managerOrganization/deleteByOrganizationIdList',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                          this.searchOrg();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败：'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络错误');
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            saveOrg(formName) {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error('请正确填写信息！');
                        return false;
                    }else {
                        let url = "/managerOrganization/addOrganization";
                        let orgId = this.formData.organizationId;
                        if(orgId) {
                            url = "/managerOrganization/updateOrganization";
                        }
                        let params = this.formData;
                        https.fetchPost(url,params ,"json").then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if(code == '200') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.handleDialogClose();
                                this.searchOrg();
                              this.searchParentOrg();
                            } else {
                                this.$message.error('操作失败:'+msg);
                            }

                        }).catch(err=>{
                                console.log(err);
                                this.$message.error('网络错误');
                            }
                        )
                    }
                });
            },
          handleCurrentChange(val) {
            this.searchOrg(val);
          },
          searchOrg(val) {
            if(val) {
              this.searchData.page = val;
            } else {
              this.searchData.page = 1;
              this.currentPage = 1;
            }
            this.searchData.size = this.pageSize;
            let params = this.searchData;
            https.fetchGet('/managerOrganization/searchOrganization',JSON.parse(JSON.stringify(params)) ).then((data) => {
              let code = data.data.code;
              if(code == '200') {
                this.orgData = data.data.data.list;
                for(let i in data.data.data.list) {
                  let org = data.data.data.list[i];
                  if(org.status === 1) {
                    this.$set(this.statusText,org.orgCode,"启用");
                  }
                  if(org.status === 2) {
                    this.$set(this.statusText,org.orgCode,"停用");
                  }
                }
                this.total = data.data.data.total;
                this.loading = false;
              }
            }).catch(err=>{
                  console.log(err)
                }
            )
          },

          searchParentOrg() {
            https
                .fetchGet('/managerOrganization/getOrganizationList?level=1', '', 'from')
                .then((data) => {
                  let code = data.data.code;
                  let msg = data.data.msg;
                  if (code == 200) {
                    this.org = data.data.data;
                  } else {
                    this.$message({
                      type: 'info',
                      message: msg
                    });
                  }
                })
                .catch((err) => {
                  this.$message.error('网络错误');
                });
          },
          
          loadCourseCategory() {
            let params = {};
            https.fetchPost('/courseCategoryInfo/selectListRecursion',params, 'json' ).then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if(code == 200) {
                let d = data.data.data;
                for(let index in d) {
                  this.courseData.push(d[index]);
                }
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:'+msg
                });
              }

            }).catch(err=>{
                  this.$message.error('网络错误');
                }
            );
          },
        },
        created: function () {
          this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
          this.searchOrg();
          this.searchParentOrg();
          this.loadCourseCategory();
        }
    }
</script>

<style >
    .but-cls {
        margin-bottom: 10px;
    }
    .hide .el-upload--picture-card {
        display: none;
    }
</style>